
export default {
  name: 'PrebuiltPromotionCards',
  values: {
    locationId: 'prebuilt_cards',
    reportLoadingStatus: false,
  },
  meta: {
    extendable: false,
  },
}
